import React from 'react';

import { CheckboxGroup } from '../../../../library/checkbox/checkbox';
import Typography from '../../../../library/typography/typography';
import FilterOption from '../filter-option/filter-option';

import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import styles from './fleet-preferred-product-category.scss';

interface FilterValue {
  categoryCode: string;
  categoryName: string;
  description: string;
  valueCode: string;
  valueName: string;
}

interface FleetPreferredProductCategoryProps {
  disabled?: boolean;
  filterValues: FilterValue[];
  onClick: () => void;
  selectedFilters: FilterValue[];
}

function FleetPreferredProductCategory(
  props: FleetPreferredProductCategoryProps
) {
  const { disabled, filterValues, onClick, selectedFilters } = props;
  const sortedFilterValues = filterValues?.sort((a, b) =>
    a?.categoryCode.localeCompare(b?.categoryCode)
  );

  function isSelectedFilter(filterValue) {
    if (!Array.isArray(selectedFilters)) {
      return false;
    }

    return selectedFilters.some(
      selectedFilter =>
        selectedFilter.valueCode === filterValue?.valueCode &&
        selectedFilter.categoryCode === filterValue?.categoryCode
    );
  }

  if (!isArrayWithLength(sortedFilterValues)) {
    return null;
  }
  return (
    <>
      <div className={styles['container']}>
        {isArrayWithLength(sortedFilterValues) && (
          <CheckboxGroup groupTitle="Fleet Preferred Products">
            <ul className={styles['fleet-preferred-options']}>
              {sortedFilterValues.map((filterValue, idx) => (
                <>
                  <FilterOption
                    categoryCode={filterValue?.categoryCode}
                    categoryName={filterValue?.categoryName}
                    isDisabled={disabled}
                    isSelected={isSelectedFilter(filterValue)}
                    key={`filteroption-${filterValue?.valueCode}-${idx}`}
                    label={filterValue?.categoryName}
                    onClick={onClick}
                    valueCode={filterValue?.valueCode}
                    valueName={filterValue?.valueName}
                  />
                  {filterValue?.description && (
                    <Typography
                      className={`${styles['description']} ${
                        disabled ? styles['disabled'] : ''
                      }`}
                    >
                      {filterValue?.description}
                    </Typography>
                  )}
                </>
              ))}
            </ul>
          </CheckboxGroup>
        )}
      </div>
    </>
  );
}

export default FleetPreferredProductCategory;
